// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-with-large-text-right/image-with-large-text-right.component.scss
// module id = 546
// module chunks = 0